import axios from "axios/index";
import {getAPIUrl} from "@esnpm/node-toolbox";
import Promise from "bluebird";
export const API_SESSION_UPDATE_TOTAL_REQUEST = "API_SESSION_UPDATE_TOTAL_REQUEST";
export const API_SESSION_UPDATE_TOTAL_SUCCESS = "API_SESSION_UPDATE_TOTAL_SUCCESS";
export const API_SESSION_UPDATE_TOTAL_FAILURE = "API_SESSION_UPDATE_TOTAL_FAILURE";

export const api_session_update_total_request = (options) => {
	return {
		type: API_SESSION_UPDATE_TOTAL_REQUEST,
		options: options,
		payload: {
			loading: true
		}
	};
};

export const api_session_update_total_success = (data) => {
	return {
		type: API_SESSION_UPDATE_TOTAL_SUCCESS,
		payload: {
			loading: false,
			data: data,
			error: null
		}
	};
};

export const api_session_update_total_failure = (error) => {
	return {
		type: API_SESSION_UPDATE_TOTAL_FAILURE,
		payload: {
			loading: false,
			error: error
		}
	};
};

/*
	Session.apiSessionUpdateTotal
*/
export const apiSessionUpdateTotal = (options) =>
	// eslint-disable-next-line no-unused-vars
	(dispatch, getState) => new Promise(
		// eslint-disable-next-line no-unused-vars
		(resolve, reject) => {
			dispatch(api_session_update_total_request(options));
			const url=getAPIUrl([
				{"url": "/api/session/update/total", "parameters": []},
			], options);
			axios({
				method: "get",
				url: url,
			}).then(
				(response) => {
					if (response.data.SUCCESSFUL) {
						dispatch(api_session_update_total_success(response.data.DATA));
						resolve();
					} else {
						dispatch(api_session_update_total_failure(response.data));
						resolve();
					}
				},
				(err) => {
					// eslint-disable-next-line no-console
					console.log(err);
					reject();
				}
			);
		}
	);
